// Unpublished Work © 2023-2026 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import LaborReport from 'OnLabor/report/labor-report';
import WorkboardReport from 'OnLabor/report/workboard-report';
import {withRouter} from 'react-router-dom';

const laborReportPages = {
    'labor': LaborReport,
    'workboard': WorkboardReport
};

function ReportWrapper(props) {
    const {
        translations,
        match: {params: {type}}
    } = props;

    const ReportComponentToRender = React.useMemo(
        () => laborReportPages[type],
        [type]
    );

    const isWorkboard = type === 'workboard';

    return (
        <div
            className='report-wrapper'
            style={{
                flexGrow: 1,
                overflow: 'hidden',
                ...isWorkboard && {
                    position: 'relative'
                }
            }}
        >
            {isWorkboard ? (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }}
                >
                    <ReportComponentToRender
                        translations={translations}
                    />
                </div>
            ) : (
                <ReportComponentToRender
                    translations={translations}
                />
            )}
        </div>
    );
}

ReportWrapper.propTypes = {
    match: PropTypes.match,
    translations: PropTypes.translations
};

export default withRouter(ReportWrapper);
